import React, { useEffect } from "react";
import { useState, useRef, useCallback } from "react";
import { Bar, getElementAtEvent } from "react-chartjs-2";

import html2canvas from "html2canvas";
import { MDBCard } from "mdb-react-ui-kit";

import PDFModal from "../PDFModal";
import "../../css/EmployeeCard.css";

import { StyleSheet } from "@react-pdf/renderer";
import EmployeeTraining from "../Employee/EmployeeTraining";
import EmployeeComp from "../Employee/EmployeeComp";
import EmployeeDetails from "../Employee/EmployeeDetails";

function scoreToGrade(score) {
  if (score >= 0 && score < 0.25) {
    return "beginner";
  } else if (score >= 0.25 && score < 0.5) {
    return "intermediate";
  } else if (score >= 0.5 && score < 0.75) {
    return "experienced";
  } else if (score >= 0.75 && score <= 1) {
    return "proficient";
  } else {
    return "";
  }
}
function scoreToColor(score) {
  if (score >= 0 && score < 0.25) {
    return "#C62917";
  } else if (score >= 0.25 && score < 0.5) {
    return "#EDA500";
  } else if (score >= 0.5 && score < 0.75) {
    return "#66B32E";
  } else if (score >= 0.75 && score <= 1) {
    return "#3F4F9F";
  } else {
    return "";
  }
}

function EmployeeCard({ employeeData, ksaData }) {
  const [activeTab, setActiveTab] = useState("EmpDetails");
  const [show, setShow] = useState(false);
  const [, updateState] = useState();
  const [imageUrl, setImageUrl] = useState("");

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const genChartImage = () => {
    const chart = document.getElementById("actualChart");

    html2canvas(chart).then(function (canvas) {
      setImageUrl(canvas.toDataURL("image/jpeg", 1.0));
    });
    //console.log("Done");
  };

  const toggleShow = () => {
    setActiveTab("CompRollup");
    setTimeout(function () {
      genChartImage();
    }, 1000);
    setShow(!show);
  };

  return (
    <>
      {employeeData !== "" ? (
        <>
          <div className="empColumnMain">
            <div className="empOthers2">
              <MDBCard href="#" className="empExportCard2">
                Export PDF
                <a
                  href="#!"
                  onClick={toggleShow}
                  className="stretched-link"
                ></a>
              </MDBCard>
              <MDBCard
                className="empScoreCard2"
                style={{
                  backgroundColor: employeeData["color"],
                }}
              >
                <img
                  src={require(`../../images/grade-${employeeData["employee grade"]}-hollow.png`)}
                  alt="..."
                />
                Employee Overall Score
              </MDBCard>
            </div>
            <div className="empDetails">
              <EmployeeDetails employeeData={employeeData} />
            </div>
            <div className="empComp">
              <MDBCard className="empCompTitle">
                Cybersecurity Competencies Level Rollup
              </MDBCard>
              <EmployeeComp
                ksaData={ksaData}
                imageUrl={imageUrl}
                setImageUrl={setImageUrl}
              />
            </div>
            <div className="empOthers">
              <MDBCard
                className="empScoreCard"
                style={{
                  backgroundColor: employeeData["color"],
                }}
              >
                <img
                  src={require(`../../images/grade-${employeeData["employee grade"]}-hollow.png`)}
                  alt="..."
                />
                Employee Overall Score
              </MDBCard>
              <MDBCard href="#" className="empExportCard">
                Export PDF
                <a
                  href="#!"
                  onClick={toggleShow}
                  className="stretched-link"
                ></a>
              </MDBCard>
            </div>
          </div>
          <div className="empColumnMain">
            <MDBCard className="recommendTrainCard">
              Recommended Training
            </MDBCard>
          </div>
          <EmployeeTraining employeeData={employeeData} />
        </>
      ) : (
        <div></div>
      )}

      {imageUrl !== "" && (
        <PDFModal
          show={show}
          handleClose={handleClose}
          profile={employeeData}
          ksa={ksaData}
          imageUrl={imageUrl}
        />
      )}
    </>
  );
}

export default EmployeeCard;
